<template>
  <div class="form auth-boxed">
    <div class="form-container outer">
      <div class="form-form">
        <div class="form-form-wrap">
          <div class="form-container">
            <div class="form-content p-5">
              <form @submit.prevent="submit">
                <h1>Potwierdzenie logowania</h1>
                <p class="text-start">Na Twój adres email został wysłany 6-cyfrowy kod. Wpisz go poniżej:</p>
                <input v-model="code" class="form-control" type="text" placeholder="Kod 2FA" maxlength="6"/>
                <div class="form-check mt-2 text-start mb-4">
                  <input type="checkbox" v-model="remember" class="form-check-input" id="rememberDevice">
                  <label class="form-check-label" for="rememberDevice">Zapamiętaj to urządzenie na 30 dni</label>
                </div>
                <div class="text-start">
                  <div v-if="message" class="alert alert-success text-start" role="alert">
                    {{ message }}
                  </div>
                  <div v-if="error" class="alert alert-danger text-start" role="alert">
                    {{ error }}
                  </div>

                </div>
                <div class="text-start">
                  <button class="btn btn-primary mt-3" :disabled="isSubmitting">Potwierdź</button>

                  <button
                      class="btn btn-outline-secondary mt-3 float-end"
                      :disabled="resendDisabled"
                      @click="resendCode"
                      type="button"
                  >
                    <span v-if="resendDisabled">Wyślij ponownie za {{ countdown }}s</span>
                    <span v-else>Wyślij kod ponownie</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {router} from '@inertiajs/vue3';

export default {
  data() {
    return {
      message: null,
      error: null,
      code: '',
      remember: false,
      resendDisabled: true,
      countdown: 30,
      countdownTimer: null,
      isSubmitting: false,
    };
  },
  mounted() {
    this.startCountdown();
  },
  methods: {
    submit() {
      this.isSubmitting = true;
      this.message = null;
      this.error = null;

      router.post(route('2fa.verify.post'), {
        code: this.code,
        remember: this.remember
      }, {
        preserveScroll: true,
        onSuccess: () => {
          this.isSubmitting = true;
          this.resendDisabled = true;
          this.message = 'Kod potwierdzony. Trwa logowanie...';
          setTimeout(() => {
            router.visit(route('dashboard.index'))
          }, 1000)
        },
        onError: (errors) => {
          this.error = errors.code || 'Błędny kod 2FA.';
        },
        onFinish: () => {
          this.isSubmitting = false;
        }
      });
    },

    async resendCode() {
      this.message = null;
      this.error = null;

      try {
        await axios.post(route('2fa.resend'));

        this.message = 'Kod został wysłany ponownie.';
        this.startCountdown();

      } catch (err) {
        console.error(err);
        this.error = 'Nie udało się wysłać kodu. Spróbuj ponownie.';
      }

      this.startCountdown();
    },

    startCountdown() {
      this.resendDisabled = true;
      this.countdown = 30;

      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }

      this.countdownTimer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(this.countdownTimer);
          this.resendDisabled = false;
        }
      }, 1000);
    }
  }
};

</script>
